import numeral from 'numeral';

numeral.register('locale', 'de', {
    delimiters: {
        thousands: '.',
        decimal: ',',
    },
});
